import { apiClient } from '@/lib/api.ts'

export function getBankAccounts(tenantId: string) {
  return apiClient.get('/buchhaltung/accounts', { params: { tenantId } })
}

export function deleteBankAccount(id: string) {
  return apiClient.delete(`/buchhaltung/accounts/${id}`)
}

export function importBankAccountsFromSap(tenantId: string) {
  return apiClient.post<{ imported: number; duplicates: number; noIban: number; total: number }>(
    '/buchhaltung/accounts/import-from-sap',
    { tenantId },
  )
}

export function createBankAccount(data: Record<string, unknown>) {
  return apiClient.post('/buchhaltung/accounts', data)
}

export function finalizeRequisition(accountId: string) {
  return apiClient.post(`/buchhaltung/requisitions/${accountId}/finalize`, {})
}

export function createRequisition(data: Record<string, unknown>) {
  return apiClient.post('/buchhaltung/requisitions', data)
}

export function getInstitutions(tenantId: string, country: string) {
  return apiClient.get('/buchhaltung/institutions', { params: { tenantId, country } })
}

export function importBatchTransactions(
  tenantId: string,
  files: Array<{ filename: string; content: string }>,
) {
  return apiClient.post('/buchhaltung/sap/import-batch', { tenantId, files })
}
